// extracted by mini-css-extract-plugin
module.exports = {"boxInput":"_5uf4GJzYmnZOpNbmSyo3e","input":"_108nOH170kIWtwvHqr9Szj"};